import { Row, Text } from 'components';
import { getModerationPolicy, theme, updateModerationPolicy } from 'lib';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Toggle } from './ui';

/**
 * System-wide moderation switches, shown above the tabs. Toggles save
 * immediately — a kill-switch shouldn't sit behind a draft/save flow.
 */
const SystemBar = () => {
  const dispatch = useDispatch();
  const [policy, setPolicy] = useState(null);
  const [saving, setSaving] = useState(null); // 'enabled' | 'failOpen'

  useEffect(() => {
    (async () => {
      const res = await getModerationPolicy();
      if (res?.data) setPolicy(res.data);
    })();
  }, []);

  const handleToggle = async (key) => {
    if (!policy || saving) return;
    const value = !policy[key];
    setSaving(key);
    const res = await updateModerationPolicy({ [key]: value });
    setSaving(null);

    if (res?.err || !res?.data) {
      dispatch({ type: 'HANDLE_RES', payload: { err: res?.err || 'Failed to update.' } });
      return;
    }
    setPolicy(res.data);
    dispatch({
      type: 'HANDLE_RES',
      payload: {
        res:
          key === 'enabled'
            ? `Moderation ${res.data.enabled ? 'enabled' : 'disabled'}.`
            : `Fail-open ${res.data.failOpen ? 'on' : 'off'}.`
      }
    });
  };

  // Loading / 403: the bar just stays hidden — tabs render their own states.
  if (!policy) return null;

  return (
    <div className="w-full mb-4">
      <div className="bg-white border border-[#D2D8DF] rounded-xl px-4 py-3 flex flex-wrap items-center gap-x-8 gap-y-2">
        <Row center noFlex gap="10px">
          <Toggle
            on={policy.enabled}
            disabled={saving === 'enabled'}
            onToggle={() => handleToggle('enabled')}
          />
          <div className="flex flex-col">
            <Text b2 bold marg="0" style={{ fontSize: '13px' }}>
              Moderation
            </Text>
            <Text c1 col={theme.GREY_60} marg="0" style={{ fontSize: '11px' }}>
              Master switch — Azure analysis and the profanity word list
            </Text>
          </div>
        </Row>

        <Row center noFlex gap="10px">
          <Toggle
            on={policy.failOpen}
            disabled={saving === 'failOpen'}
            onToggle={() => handleToggle('failOpen')}
          />
          <div className="flex flex-col">
            <Text b2 bold marg="0" style={{ fontSize: '13px' }}>
              Fail-open
            </Text>
            <Text c1 col={theme.GREY_60} marg="0" style={{ fontSize: '11px' }}>
              If Azure errors, allow content instead of blocking it
            </Text>
          </div>
        </Row>

        {!policy.enabled && (
          <span className="ml-auto text-[11.5px] font-semibold text-[#E11D48] bg-[#FFF1F2] border border-[#FECDD3] rounded-full px-3 py-1">
            Moderation is disabled — all content is allowed
          </span>
        )}
      </div>
    </div>
  );
};

export default SystemBar;
